// @flow

import React from "react";
import ReactDOM from "react-dom";
import ReactFormLoader from "../components/ReactFormLoader";

const els = document.querySelectorAll(".react-form-loader");
els.forEach((el: HTMLElement) => {
    const form = window.form;
    ReactDOM.render(
        <ReactFormLoader
            elements={form.elements}
            form_build_id={form.form_build_id}
            form_id={form.form_id}
            form_token={form.form_token}
            submit={form.submit}
            errors={form.errors}
            captcha={form.captcha}
        />,
        el
    );
});
